
export const ENCRYPT = `/mobile/encrypt`;
export const DECRYPT = `/mobile/decrypt`;